import { pcMilerWebServicesEnvironment } from '../pc-miler-web-services-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { pcmWsAvoidFavorInfoSchema } from '../schemas/pcm-ws-avoid-favor-info';
import { PcmWsAuthHeaders } from '../../../models/pcm-ws-auth-headers';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

interface RequestOptions {
  dataSet?: string;
  detail?: boolean;
}

/**
 * Get a list of AvoidFavors that belong to the given Avoid/Favor Set
 * @param setId The ID of the Avoid/Favor Set
 * @param options Optional Request Options
 * @returns An array of AvoidFavors that belong to the given Avoid/Favor Set
 */
export function getAvoidFavorSetsSetIdGroups(
  this: unknown,
  setId: number,
  options?: RequestOptions
) {
  const params = new URLSearchParams();

  if (typeof options?.dataSet !== 'undefined') {
    params.append('dataSet', options.dataSet);
  }
  if (typeof options?.detail !== 'undefined') {
    params.append('detail', options.detail.toString());
  }

  return fromFetch(
    new Request(
      `${pcMilerWebServicesEnvironment.resolve(this).avoidFavorSetsSetIdGroupsUrl(setId)}${typeof options === 'undefined' ? '' : `?${params.toString()}`}`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new PcmWsAuthHeaders(),
        },
      }
    )
  ).pipe(selectData(z.array(pcmWsAvoidFavorInfoSchema)));
}
